import { Select, SelectProps } from "antd"
import React from "react"
import { ArrowDown } from "@css/icons/SVG"

type Props = {} & SelectProps
export function DealSelectFilter({ ...rest }: Props) {
    return (
        <Select
            mode="multiple"
            {...rest}
            dropdownMatchSelectWidth
            virtual={false}
            listHeight={400}
            showArrow
            maxTagCount={1}
            maxTagTextLength={18}
            maxTagPlaceholder={(c) => "+" + c.length}
            tagRender={(props) => <div>{props.label}</div>}
            suffixIcon={<ArrowDown />}
        />
    )
}
